var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"context-menu-demo"}},[_c('context-menu-simple'),_c('context-menu-click-not-close')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }